import { buildActivityTimelineModel } from './buildActivityTimelineModel'
import { hasThoughtTimelineExtras } from './thoughtTimelineExtras'

export function activityTimelineModel(input) {
  const model = buildActivityTimelineModel(input)
  return {
    ...model,
    visible:
      model.hasPublicTimeline ||
      !model.view.isEmpty ||
      hasThoughtTimelineExtras({
        leading: model.leadingExtras,
        trailing: model.trailingExtras,
      }) ||
      Boolean(input.thoughtSummary),
  }
}
